import { Clock, Eye, CheckCircle2, XCircle, Inbox, Reply } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export const QuoteStatusBadge = ({ status }) => {
  const styles = {
    pending: 'bg-amber-100 text-amber-800 border-amber-300',
    reviewed: 'bg-blue-100 text-blue-800 border-blue-300',
    approved: 'bg-green-100 text-green-800 border-green-300',
    rejected: 'bg-red-100 text-red-800 border-red-300'
  };
  const icons = {
    pending: Clock,
    reviewed: Eye,
    approved: CheckCircle2,
    rejected: XCircle
  };
  const Icon = icons[status] || Clock;
  
  return (
    <Badge className={`${styles[status] || styles.pending} flex items-center gap-1`}>
      <Icon className="w-3 h-3" />
      {status?.charAt(0).toUpperCase() + status?.slice(1)}
    </Badge>
  );
};

export const ContactStatusBadge = ({ status }) => {
  const styles = {
    new: 'bg-amber-100 text-amber-800 border-amber-300',
    read: 'bg-blue-100 text-blue-800 border-blue-300',
    replied: 'bg-green-100 text-green-800 border-green-300'
  };
  const icons = {
    new: Inbox,
    read: Eye,
    replied: Reply
  };
  const Icon = icons[status] || Inbox;
  
  return (
    <Badge className={`${styles[status] || styles.new} flex items-center gap-1`}>
      <Icon className="w-3 h-3" />
      {status?.charAt(0).toUpperCase() + status?.slice(1)}
    </Badge>
  );
};

export const getModeIconStyle = (mode) => {
  const styles = {
    air: 'bg-blue-100 text-blue-600',
    ocean: 'bg-cyan-100 text-cyan-600',
    road: 'bg-amber-100 text-amber-600'
  };
  return styles[mode] || 'bg-purple-100 text-purple-600';
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(hours / 24);

  if (hours < 1) return 'Just now';
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString();
};

export const PACKAGING_LABELS = {
  wooden_crate: 'Wooden Crate / Jaula de Madera',
  pallet: 'Pallet / Tarima',
  cardboard_box: 'Cardboard Box / Caja de Cartón',
  shrink_wrap: 'Shrink Wrap / Embalaje Termoencogible',
  foam_protection: 'Foam Protection / Protección de Espuma',
  bubble_wrap: 'Bubble Wrap / Plástico de Burbujas',
  steel_container: 'Steel Container / Contenedor de Acero',
  climate_controlled: 'Climate Controlled / Empaque Climatizado',
  vacuum_sealed: 'Vacuum Sealed / Sellado al Vacío',
  custom: 'Custom / Personalizado'
};
